import { render, staticRenderFns } from "./BpStatisticsModular.vue?vue&type=template&id=15f6b828&scoped=true&"
import script from "./BpStatisticsModular.vue?vue&type=script&lang=js&"
export * from "./BpStatisticsModular.vue?vue&type=script&lang=js&"
import style0 from "./BpStatisticsModular.vue?vue&type=style&index=0&id=15f6b828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6b828",
  null
  
)

export default component.exports